import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';

export const LEAD_TEST_IDS = {
    FIELD_NAME: 'name-surname',
    FIELD_EMAIL: 'email-address',
    FIELD_COMPANY_CODE: 'company-code-name',
    FIELD_PHONE: 'phone-number',
    FIELD_PRODUCT_TYPE: 'product-type',
    FIELD_COMMENT: 'comment',
    FIELD_ADDRESS: 'address',
    LEAD_FORM: 'lead-form',
    SUBMIT_BUTTON: 'lead-submit-button',
    RETRY_BUTTON: 'lead-retry-button',
    CLOSE_BUTTON: 'lead-close-button',
    SUCCESS_NOTIFICATION: 'lead-success-notification',
    ERROR_NOTIFICATION: 'lead-error-notification',
    OPEN_MODAL_BUTTON: 'lead-open-modal-button',
};

export const API = {
    URL_LEAD_SUBMIT: '/ajax/leads/{segment}',
};

if (checkShouldUseMocks({ shouldUseInTest: true })) {
    API.URL_LEAD_SUBMIT = '/api/leads/{segment}';
}

export const MUTATION_KEY = {
    SUBMIT_LEAD: 'lead-submit',
};

export const TRACKER_CLIENT_ID_VALUE = 0;
